// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"6d37491f","110":"1a8d0676","166":"52ec68a9"}[chunkId] + ".chunk.js";
};